// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { totalImpressionsConfig } from '@/lib/analytics/kpis/pinterest/totalImpressions';
import { SIZE_50 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerImpressionsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> =
    {
        ...totalImpressionsConfig,
        id: 'impressions',
        size: SIZE_50,
        tooltip: null,
        loader: MediaViewerKpiLoader
    };
